import { Box, Grid } from "@mui/material";
import Topbar from "./components/Topbar";
import Stream from "./components/Stream";
import classes from "./App.module.css";
import image1 from "./assets/zohar_river_2.jpg";

function App() {
  return (
    <div className="App">
      <img className={classes.mainImage} alt={"zohar river"} src={image1} />
      <div className={classes.mainImageEffect}></div>
      <header>
        <Topbar />
      </header>
      <div className={classes.mainLayer}>
        <Box
          sx={{ flexGrow: 1 }}
          display={"flex"}
          alignItems={"center"}
          height={"100vh"}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} md={4} lg={2} display>
              <iframe
                style={{ borderRadius: "12px" }}
                src="https://open.spotify.com/embed/track/3BwCZj8cyVLepN1dcSZZgs?utm_source=generator"
                width="100%"
                height="352"
                frameBorder={0}
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
              ></iframe>
              <Stream />
            </Grid>
            <Grid item xs={0} md={8} lg={10}></Grid>
          </Grid>
        </Box>
      </div>
    </div>
  );
}

export default App;
